import "./AddNode.less";

import * as React from "react";

import { IBaseProps } from "lib/data/interfaces";

import { Button, Input } from "antd";
import { MinimizeButton } from "components/general/StandardButtons";



interface IAddNodeProps extends IBaseProps {
	defaultValue?: string;
	isActive: boolean;
	closeEdit?: () => void;
	onSave: (value: string) => void;
}

interface IAddNodeState {
	currentValue: string;
}


export class AddNode extends React.Component<IAddNodeProps, IAddNodeState> {

	constructor(props: IAddNodeProps) {

		super(props);

		this.state = {
			currentValue: ""
		};
	}

	public componentWillMount = () => {

		// Check For Default Value
		if (this.props.defaultValue !== undefined) {

			// Set Initial Value
			this.setState({ currentValue: this.props.defaultValue });
		}
	}

	public inputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {

		// Get Latest Value
		const { value } = e.target;

		// Set Latest Value
		this.setState({ currentValue: value });
	}

	public onSave = () => {

		// Call Save Handler
		this.props.onSave(this.state.currentValue);
	}

	public render() {

		return (
			<div className={"add-node"}>
				<MinimizeButton className="add-node-button" onClick={this.props.closeEdit} />
				<Input autoFocus={this.props.isActive} value={this.state.currentValue} onChange={this.inputHandler} />
				<Button type={"primary"} shape="circle" icon={"enter"} className={"enter-node add-node-button"} size={"small"} onClick={this.onSave} />
			</div>
		);
	}
}
